import { Preferences } from '@capacitor/preferences';
import { StorageRepository } from './StorageRepository';

export class StorageRepositoryCapacitor implements StorageRepository {
  async getItem({ key }: { key: string }): Promise<string | null> {
    const result = await Preferences.get({ key });
    return result.value;
  }
  async setItem({ key, item }: { key: string; item: string }): Promise<void> {
    return Preferences.set({
      key: key,
      value: item,
    });
  }
  async removeItem({ key }: { key: string }): Promise<void> {
    return Preferences.remove({ key });
  }
}
